// @ts-nocheck
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { getLoadVariantIdForProducts } from "@store/Framework/Common/Utilities/loadProductHelper";
import loadVariantChildrens from "@store/Framework/Store/Data/Products/Handlers/LoadVariantChildrens";
import { getVariantChildrenDataView } from "@store/Modules/client-framework/src/Store/Data/Products/ProductsSelectors";
import { executeAwaitableHandlerChain } from "@toolkit/Modules/client-framework/HandlerCreator";
import groupBy from "lodash/groupBy";

const loadVariantChildrenIfNeeded = (handlerProps: any, products: ProductModel[] | null | undefined) => {
    if (!products?.length) {
        return;
    }

    const variantProducts = products.filter(x => x.properties.parentNumber);
    const groupedVariantProducts = groupBy(variantProducts, x => x.properties.parentNumber);

    Object.values(groupedVariantProducts).forEach(async groupProducts => {
        const productId = getLoadVariantIdForProducts(groupProducts);
        const dataView = getVariantChildrenDataView(handlerProps.getState(), productId);

        if (!dataView.isLoading && !dataView.value) {
            await executeAwaitableHandlerChain(loadVariantChildrens, { products: groupProducts }, handlerProps);
        }
    });
};

export default loadVariantChildrenIfNeeded;
